import React from "react";
import * as Mui from "@mui/material";
import { AgentPublicBio } from "model/agent";
import { ValidationErrors } from "../validation";
import * as styles from "../styles";

interface Props {
	publicBio: AgentPublicBio;
	errors: ValidationErrors;
	onUpdateField: <K extends keyof AgentPublicBio>(field: K, value: AgentPublicBio[K]) => void;
}

export const SocialMediaLinksSection: React.FC<Props> = ({
	publicBio,
	errors,
	onUpdateField,
}) => {
	return (
		<>
			<Mui.Grid item xs={12}>
				<Mui.Typography style={styles.sectionTitleWithDescription}>
					Social Media
				</Mui.Typography>
				{/* No marginBottom here: the 24px gap to the fields comes from the parent Grid
				    spacing alone, so description + grid spacing don't stack to ~48px (MAX-3868). */}
				<Mui.Typography style={{ ...styles.descriptionText, marginBottom: 0 }}>
					Social media links will display at the top of the bio page along with other contact information.
				</Mui.Typography>
			</Mui.Grid>

			<Mui.Grid item xs={12}>
				<Mui.Typography style={styles.fieldLabel}>
					LinkedIn
				</Mui.Typography>
				<Mui.TextField
					fullWidth
					placeholder="https://linkedin.com/in/yourprofile"
					value={publicBio.linkedinUrl || ''}
					onChange={(e) => onUpdateField('linkedinUrl', e.target.value)}
					error={!!errors.linkedinUrl}
					helperText={errors.linkedinUrl}
					variant="outlined"
					size="small"
				/>
			</Mui.Grid>

			<Mui.Grid item xs={12}>
				<Mui.Typography style={styles.fieldLabel}>
					Facebook
				</Mui.Typography>
				<Mui.TextField
					fullWidth
					placeholder="https://facebook.com/yourpage"
					value={publicBio.facebookUrl || ''}
					onChange={(e) => onUpdateField('facebookUrl', e.target.value)}
					error={!!errors.facebookUrl}
					helperText={errors.facebookUrl}
					variant="outlined"
					size="small"
				/>
			</Mui.Grid>

			<Mui.Grid item xs={12}>
				<Mui.Typography style={styles.fieldLabel}>
					Instagram
				</Mui.Typography>
				<Mui.TextField
					fullWidth
					placeholder="https://instagram.com/yourhandle"
					value={publicBio.instagramUrl || ''}
					onChange={(e) => onUpdateField('instagramUrl', e.target.value)}
					error={!!errors.instagramUrl}
					helperText={errors.instagramUrl}
					variant="outlined"
					size="small"
				/>
			</Mui.Grid>

			<Mui.Grid item xs={12}>
				<Mui.Typography style={styles.fieldLabel}>
					X (formerly Twitter)
				</Mui.Typography>
				<Mui.TextField
					fullWidth
					placeholder="https://x.com/yourhandle"
					value={publicBio.twitterUrl || ''}
					onChange={(e) => onUpdateField('twitterUrl', e.target.value)}
					error={!!errors.twitterUrl}
					helperText={errors.twitterUrl}
					variant="outlined"
					size="small"
				/>
			</Mui.Grid>

			<Mui.Grid item xs={12}>
				<Mui.Typography style={styles.fieldLabel}>
					TikTok
				</Mui.Typography>
				<Mui.TextField
					fullWidth
					placeholder="https://tiktok.com/@yourhandle"
					value={publicBio.tiktokUrl || ''}
					onChange={(e) => onUpdateField('tiktokUrl', e.target.value)}
					error={!!errors.tiktokUrl}
					helperText={errors.tiktokUrl}
					variant="outlined"
					size="small"
				/>
			</Mui.Grid>
		</>
	);
};
